/**
 * This allows you to imitate a network call or to wait for somehting to happen before execution continues
 * @param ms milliseconds to wait for
 * @returns A promise which resolves after the given ms have passed
 */
export function sleep(ms: number) {
    return new Promise((r) => setTimeout(r, ms));
}